import { Helmet } from 'react-helmet-async'
import { strings } from "../assets/resources/translations"

const NotFound = () => {
	return (<div className="booking-form">
		<Helmet>
			<title>404 - Not found</title>
			<meta name="description" content="Not found" />
			<meta property="og:site_name" content={window.location.origin} />
			<meta property="og:url" content={window.location} />
			<meta property="og:title" content="404 - Not found" />
			<meta property="og:description" content="Not found" />
		</Helmet>
		<div className="form-section">
			<div className="text" dangerouslySetInnerHTML={{ __html: strings.pageNotFound }} />
		</div>	</div>)
}
export default NotFound